import { PrescriptionService } from '@/services/prescription.service';
export default {
  props: {
    prescriptionData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      showDialog: false,
      alert: {
        show: false,
        message: ''
      },
      processing: false
    };
  },
  methods: {
    showAlert(msg) {
      this.alert.show = true;
      this.alert.message = msg;
    },
    async onCancelPendingOrder() {
      this.alert.show = false;
      try {
        this.processing = true;
        await PrescriptionService.cancelPendingOrder(this.prescriptionData.id);
        setTimeout(() => {
          this.$emit('refresh-prescriptions', 'push-scheduled-prescription');
        }, 3000);
        this.processing = false;
        this.showDialog = false;
      } catch (err) {
        this.showAlert(err);
        this.processing = false;
      }
    }
  }
};